import { render, staticRenderFns } from "./HowToRegister.vue?vue&type=template&id=1df0c058&"
import script from "./HowToRegister.vue?vue&type=script&lang=js&"
export * from "./HowToRegister.vue?vue&type=script&lang=js&"
import style0 from "./HowToRegister.vue?vue&type=style&index=0&id=1df0c058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports